export type SecurityProblemCode =
  | 'notFound'
  | 'invalidPolicy'
  | 'invalidIp'
  | 'duplicateIp'
  | 'invalidResolution'
  | 'noteRequired'
  | 'currentProtected'
  | 'permissionDenied'
  | 'stateChanged';

export class SecurityDomainError extends Error {
  readonly code: SecurityProblemCode;
  readonly status: number;
  readonly details?: Record<string, unknown>;

  constructor(
    code: SecurityProblemCode,
    status: number,
    details?: Record<string, unknown>,
  ) {
    super(code);
    this.name = 'SecurityDomainError';
    this.code = code;
    this.status = status;
    this.details = details;
  }
}
